import { getEnv } from "@trillion/ui/lib/env";
import { createApiClient } from "@trillion/ui/lib/api-client";

export interface SessionCreateParams {
  source_key?: string;
  source_partner?: string;
  referrer?: string;
  utm_source?: string;
  utm_campaign?: string;
  utm_medium?: string;
  // No geo or device members: the API resolves the visitor's market from the client IP and the device
  // type, browser and OS from the User-Agent header, server-side.
}

// help.com is a public app — no auth cookie, so credentials are omitted.
const api = createApiClient(() => getEnv("HELP_API_URL"), { credentials: "omit" });

export const helpApi = {
  async createSession(params: SessionCreateParams): Promise<{ session_id: string }> {
    return api.request<{ session_id: string }>("/api/session", {
      method: "POST",
      body: JSON.stringify(params),
    });
  },
};
